import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-nihal-dark text-white py-12">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo ve Açıklama */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <Link to="/" className="flex items-center">
          <img 
            src="/assets/logo2.png" 
            alt="Diyetisyen Nihal Kamış" 
            className="h-14 w-auto"
          />
        </Link>
            </div>
            <p className="text-nihal-secondary mb-4">
              Hedefinize ulaşmanız için kişisel beslenme planı ve diyet önerileri sunuyorum.
            </p>
            <div className="flex space-x-4">
              
              <a href="https://www.instagram.com/dyt.nihalkamis" className="text-nihal-secondary hover:text-white transition-colors">
                <i className="fab fa-instagram"></i>
              </a>
              
              <a href="https://www.linkedin.com/in/nihal-nur-kam%C4%B1%C5%9F-b28210334/" className="text-nihal-secondary hover:text-white transition-colors">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>

          {/* Hızlı Linkler */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Hızlı Linkler</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-nihal-secondary hover:text-white transition-colors">Anasayfa</Link></li>
              <li><Link to="/about" className="text-nihal-secondary hover:text-white transition-colors">Hakkımda</Link></li>
              <li><Link to="/services" className="text-nihal-secondary hover:text-white transition-colors">Hizmetler</Link></li>
              <li><Link to="/tools" className="text-nihal-secondary hover:text-white transition-colors">Hesaplama Araçları</Link></li>
              <li><Link to="/blog" className="text-nihal-secondary hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/testimonials" className="text-nihal-secondary hover:text-white transition-colors">Referanslar</Link></li>
              <li><Link to="/contact" className="text-nihal-secondary hover:text-white transition-colors">İletişim</Link></li>
            </ul>
          </div>

          {/* İletişim Bilgileri */}
          <div>
            <h3 className="text-lg font-semibold mb-4">İletişim Bilgileri</h3>
            <ul className="space-y-2">
              <li className="flex items-start">
                <svg className="w-5 h-5 mr-2 mt-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"></path>
                </svg>
                <span className="text-nihal-secondary">İstanbul, Türkiye</span>
              </li>
             
              <li className="flex items-center">
                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
                </svg>
                <span className="text-nihal-secondary">dytnihalkamis@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-nihal-secondary">
          <p>&copy; {currentYear} Diyetisyen Nihal Kamış. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
